import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import storage from "storage";

Vue.use(Router);



const router = new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: function() {
        //let user = storage.get('user') ? storage.get('user') : {}
        //return user.tipo === 'den' ? 'ordens' : 'solicitacoes'
        return 'dashboard'
      },
      component: DashboardLayout,
      children: [
        {
          path: '/painel',
          name: 'Painel',
          component: () => import('./views/Dashboard.vue')
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: () => import('./views/Dashboard.vue')
        },
        {
          path: '/laboratorios',
          name: 'Laboratórios',
          component: () => import('./views/Laboratorio/Laboratorios.vue')
        },
        {
          path: '/laboratorio/{id}',
          name: 'Laboratório',
          component: () => import('./views/Laboratorio/Laboratorio.vue')
        },
        {
          path: '/dentistas',
          name: 'Dentistas',
          component: () => import('./views/Dentista/Dentistas.vue')
        },
        {
          path: '/dentista/{id}',
          name: 'Dentista',
          component: () => import('./views/Dentista/Dentista.vue')
        },
        {
          path: 'ordens/solicitar/:id?',
          name: 'Solicitar Ordem de Serviço',
          component: () => import('./views/OrdemServicos/SolicitarOrdemServico.vue')
        },
        {
          path: '/conta',
          name: 'Minha Conta',
          component: () => import('./views/Conta/Conta.vue')
        },
        {
          path: '/ordens',
          name: 'Ordens de Serviços',
          component: () => import('./views/OrdemServicos/OrdensServicos.vue')
        },
        {
          path: '/ordens/:id',
          name: 'Detalhes da OS',
          component: () => import('./views/OrdemServicos/VerOrdemServico.vue')
        },
        {
          path: '/solicitacoes',
          name: 'Solicitações',
          component: () => import('./views/OrdemServicos/Solicitacoes.vue')
        },
        {
          path: '/solicitacao/:id',
          name: 'Detalhes da solicitação',
          component: () => import('./views/OrdemServicos/Solicitacao.vue')
        },
        {
          path: '/agenda-protetica',
          name: 'Agenda Protética',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgendaProtetica/ListaAgenda.vue')
        },
        {
          path: '/agenda-protetica/job/:data/:hora/:id?',
          name: 'Cadastro de Agenda Protética',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgendaProtetica/FormAgenda.vue')
        },
        {
          path: '/usuarios-proteticos',
          name: 'Usuários Protéticos',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgendaProtetica/ListaUsuarios.vue')
        },
        {
          path: '/usuarios-proteticos/job/:id?',
          name: 'Cadastro de Usuários Protéticos',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgendaProtetica/FormUsuarios.vue')
        },
        {
          path: '/dentistas-externos',
          name: 'Dentistas Externos',
          component: () => import(/* webpackChunkName: "demo" */ './views/DentistaExterno/ListaDentista.vue')
        },
        {
          path: '/dentistas-externos/f/:id?',
          name: 'Dentista Externo',
          component: () => import(/* webpackChunkName: "demo" */ './views/DentistaExterno/FormDentista.vue')
        },
        {
          path: '/procedimentos-proteticos',
          name: 'Procedimentos Protéticos',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgendaProtetica/ListaProcedimentos.vue')
        },
        {
          path: '/procedimentos-proteticos/cadastro/:id?',
          name: 'Cadastro de Procedimentos Protéticos',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgendaProtetica/FormProcedimentos.vue')
        },
        {
          path: '/relatorio-procedimentos',
          name: 'Relatório de Serviços',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgendaProtetica/ListaRelatorio.vue')
        },
        {
          path: '/relatorio-procedimentos/pagamentos/:idxs',
          name: 'Pagamentos de Serviços',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgendaProtetica/PagamentoServicos.vue')
        },
        {
          path: '/relatorio-solicitacoes',
          name: 'Relatório de Solicitações',
          component: () => import(/* webpackChunkName: "demo" */ './views/OrdemServicos/ListaRelatorio.vue')
        },
        {
          path: '/relatorio-solicitacoes/pagamentos/:idxs',
          name: 'Pagamentos de Solicitações',
          component: () => import(/* webpackChunkName: "demo" */ './views/OrdemServicos/PagamentoServicos.vue')
        },
        {
          path: '/estoque',
          name: 'Estoque',
          component: () => import(/* webpackChunkName: "demo" */ './views/Estoque/ListaEstoque.vue')
        },
        {
          path: '/estoque/f/:id?',
          name: 'Cadastro de Estoque',
          component: () => import(/* webpackChunkName: "demo" */ './views/Estoque/FormEstoque.vue')
        },
        {
          path: '/estoque-categoria',
          name: 'Categorias de Estoque',
          component: () => import(/* webpackChunkName: "demo" */ './views/Estoque/CategoriaList.vue')
        },
        {
          path: '/estoque-categoria/f/:id?',
          name: 'Cadastro de Categoria de Estoque',
          component: () => import(/* webpackChunkName: "demo" */ './views/Estoque/CategoriaForm.vue')
        },
        {
          path: '/estoque-fornecedor',
          name: 'Fornecedores de Estoque',
          component: () => import(/* webpackChunkName: "demo" */ './views/Estoque/FornecedorList.vue')
        },
        {
          path: '/estoque-fornecedor/f/:id?',
          name: 'Cadastro de Fornecedor de Estoque',
          component: () => import(/* webpackChunkName: "demo" */ './views/Estoque/FornecedorForm.vue')
        },
        {
          path: '/financeiro',
          name: 'Financeiro',
          component: () => import(/* webpackChunkName: "demo" */ './views/Financeiro/DashFinanceiro.vue')
        },
        {
          path: '/financeiro/cadastro/:id?',
          name: 'Cadastro de Conta',
          component: () => import(/* webpackChunkName: "demo" */ './views/Financeiro/FormFinanceiro.vue')
        },
        {
          path: '/parametros',
          name: 'Parâmetros',
          component: () => import(/* webpackChunkName: "demo" */ './views/Parametros/ListaParametros.vue')
        },
        {
          path: '/parametros/:id',
          name: 'Detalhes parâmetro',
          component: () => import(/* webpackChunkName: "demo" */ './views/Parametros/EditaParametros.vue')
        },
        {
          path: '/parametros/novo',
          name: 'Novo parâmetro',
          component: () => import(/* webpackChunkName: "demo" */ './views/Parametros/EditaParametros.vue')
        },
        {
          path: '/ficha-modelo',
          name: 'Ficha Modelo',
          component: () => import(/* webpackChunkName: "demo" */ './views/FichaModelo.vue')
        },
        {
          path: '/usuarios',
          name: 'Usuários',
          component: () => import('./views/Usuarios/ListaUsuarios.vue')
        },
        {
          path: '/usuarios/:tipo/:id',
          name: 'Detalhes de Usuário',
          component: () => import('./views/Usuarios/FormUsuarios.vue')
        },
        {
          path: '/faturas',
          name: 'Faturas',
          component: () => import('./views/Faturas.vue')
        },
        {
          path: '/assinaturas',
          name: 'Assinaturas',
          component: () => import('./views/Assinatura/Assinaturas.vue')
        },
        {
          path: '/minha-assinatura',
          name: 'Minha Assinatura',
          component: () => import('./views/Assinatura/MinhaAssinatura.vue')
        },
        {
          path: '/alterar-senha',
          name: 'Alterar Senha',
          component: () => import('./views/Login/Password.vue')
        },
        {
          path: '/cancelar-assinatura',
          name: 'Cancelar Assinatura',
          component: () => import('./views/Assinatura/Assinatura.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('./views/Login/Login.vue')
        }
      ]
    },
    //{
      //path: '/',
      //redirect: 'register',
      //component: AuthLayout,
      //children: [
        //{
          //path: '/register',
          //name: 'register',
          //component: () => import('./views/Register.vue')
        //}
      //]
    //},
    {
      path: '/',
      redirect: 'recovery',
      component: AuthLayout,
      children: [
        {
          path: '/recovery',
          name: 'recovery',
          component: () => import('./views/Login/RecoveryPassword.vue')
        }
      ]
    }
  ]
});

// Bloqueio de login
router.beforeEach((to, from, next) => {
  if (to.path != '/login' && to.path != '/register' && to.path != '/recovery' && !storage.get('user', 'token')) {
    // Se não estiver logado
    next('/login');
  } else if ((to.path == '/login' || to.path == '/recovery' || to.path == '/register') && storage.get('user', 'token')) {
    // Se estiver logado tentando acessar a tela de login, redirecionar
    next('/');
  } else next();
});

export default router;
